const page_schema = {
	"tiers": [
		{
			"name": "Application",
			"type": "checkbox",
			"id": "applications_dropdown",
			"class_name": "tags",
			"child_name": "application",
			"options": [
				{
					"name": "ChIP",
					"id": "chip"
				},
				{
					"name": "Nucleosomal",
					"id": "nucleosomal"
				},
				{
					"name": "ATAC",
					"id": "atac"
				},
			]
		},
		{
			"name": "d-none",
			"type": "checkbox",
			"id": "d-none",
			"class_name": "tags",
			"child_name": "d-none",
			"options": [
				{
					"name": "Clean-Up & Concentration",
					"id": "clean-up-concentration"
				}
			]
		},
	],
	"filters": [],
	"products": {
		"Zymo-Spin ChIP Kit": {
			"title": "Zymo-Spin ChIP Kit",
			"catalogNumbers": "D5209, D5210",
			"description": "The Zymo-Spin ChIP Kit from Zymo Research provides a streamlined ChIP procedure for investigating protein-DNA interactions that have been “fixed” in their natural state and can be used to effectively identify binding sites for transcription factors, co-factors, and other DNA regulatory proteins.",
			"handle": "/products/zymo-spin-chip-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5209_Zymo-Spin-ChIP-Kit.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "zymo-spin-chip-kit",
			"tags": [
				"chip",
			],
			filters: []
		},
		"ChIP DNA Clean & Concentrator": {
			"title": "ChIP DNA Clean & Concentrator",
			"catalogNumbers": "D5205, D5201",
			"description": "The Chromatin Immunoprecipitation (ChIP) DNA Clean & Concentrator provides a hassle-free method for the rapid purification and concentration of high-quality DNA from any step in a standard ChIP protocol. This includes samples that have undergone reverse cross-linking, Proteinase K or RNase A digestion, mechanical or nuclease-mediated DNA shearing, and samples eluted from chromatin-antibody-bead complexes. The specially formulated ChIP DNA Binding Buffer promotes DNA adsorption to the column in the presence of detergents, antibodies, and proteinases that are often used for ChIP.",
			"handle": "/products/chip-dna-clean-concentrator",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5201_ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "chip-dna-clean-concentrator",
			"tags": [
				"chip",
				"clean-up-concentration"
			],
			filters: []
		},
		"ZR-96 ChIP DNA Clean & Concentrator": {
			"title": "ZR-96 ChIP DNA Clean & Concentrator",
			"catalogNumbers": "D5206, D5207",
			"description": "The ZR-96 Chromatin Immunoprecipitation (ChIP) DNA Clean & Concentrator provides a hassle-free method for the rapid, high-throughput purification, and concentration of high-quality DNA from any step in a standard ChIP protocol. This product is well suited for samples that have undergone reverse cross-linking and Proteinase K or RNase A digestion as well as reverse cross-linked samples eluted from chromatin-antibody-bead complexes. Additionally, this product may also be used to purify DNA from PCR and other enzymatic reactions. DNA purified using the ZR-96 ChIP DNA Clean & Concentrator ™ is suitable for PCR, Next-Gen sequencing (ChIP-Seq), arrays, as well as other molecular applications.",
			"handle": "/products/zr-96-chip-dna-clean-concentrator",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5206_ZR-96-ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "zr-96-chip-dna-clean-concentrator",
			"tags": [
				"chip",
				"clean-up-concentration"
			],
			filters: []
		},
		"EZ Nucleosomal DNA Prep Kit": {
			"title": "EZ Nucleosomal DNA Prep Kit",
			"catalogNumbers": "D5220",
			"description": "The EZ Nucleosomal DNA Prep Kit is a streamlined procedure for the isolation of nucleosome-associated DNA. The kit includes reagents/procedures for the following: cell nuclei isolation, intact nuclei enzymatic digestion, and nucleosomal DNA purification. This kit includes two different enzymes for nucleosomal DNA preparation: Atlantis dsDNase and Micrococcal Nuclease. Enzymatic digestion yields very homogeneous populations of core nucleosomes and purification of the nucleosome-associated DNA is performed using Zymo Research's proven spin column technology.",
			"handle": "/products/ez-nucleosomal-dna-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5220_EZ-Nucleosomal-DNA-Prep-Kit.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "ez-nucleosomal-dna-prep-kit",
			"tags": [
				"nucleosomal",
			],
			filters: []
		},
		"Zymo-Seq ATAC Library Kit": {
			"title": "Zymo-Seq ATAC Library Kit",
			"catalogNumbers": "D5458",
			"description": "Zymo-Seq ATAC Library Kit provides a simple and streamlined workflow for Assay for Transposase Accessible Chromatin with high throughput Sequencing (ATAC-Seq) library preparation from mammalian cell and tissue input. This all-inclusive kit features an easy to follow protocol capable of preparing ATAC-Seq libraries from as little as 50,000 cells in as little as 4 hours with minimal hands on time.",
			"handle": "/products/zymo-seq-atac-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5458-Zymo-Seq-ATAC-Library-Kit_2365_002_ProductPhoto.jpg?v=1677624838&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-atac-library-kit",
			"tags": [
				"nucleosomal",
				"atac",
			],
			filters: []
		},
		"DNA Degradase Plus": {
			"title": "DNA Degradase Plus",
			"catalogNumbers": "E2020, E2021",
			"description": "DNA Degradase Plus from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleoside components. Since nucleosides lack negatively charged phosphate, DNA Degradase Plus is ideal for whole-genome DNA methylation analysis by LC/MS. Digestion with the enzyme is performed via a one-step procedure that is faster and simpler than other available methods.",
			"handle": "/products/dna-degradase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2020_DNA-Degradase-Plus.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dna-degradase-plus",
			"tags": [
				"chip",
				"nucleosomal",
			],
			filters: []
		},
		"DNA Degradase": {
			"title": "DNA Degradase",
			"catalogNumbers": "E2016, E2017",
			"description": "DNA Degradase from Zymo Research is a nuclease mix that quickly and efficiently degrades DNA to its individual nucleotide components. DNA Degradase is ideal for whole-genome DNA methylation analysis by many downstream applications (i.e., HPLC, TLC, etc.). Digestion with the enzyme is performed via a one-step procedure that is faster and simpler than other available methods.",
			"handle": "/products/dna-degradase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2016_DNA-Degradase.jpg?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "dna-degradase",
			"tags": [
				"chip",
				"nucleosomal",
			],
			filters: []
		},
		"Atlantis dsDNase": {
			"title": "Atlantis dsDNase",
			"catalogNumbers": "E2030",
			"description": "Atlantis dsDNase is a double-stranded DNA-specific endonuclease that cleaves phosphodiester bonds in DNA to yield homogeneous populations of core nucleosomes.",
			"handle": "/products/atlantis-ds-dnase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2030_Atlantis-dsDNase-12.5-U.jpg?v=1628532394&width=600",
			"generalIndex": "998",
			"id": "atlantis-ds-dnase",
			"tags": [
				"nucleosomal",
			],
			filters: []
		},
	}
}